import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { pageColors } from "../mock";
import { Instagram, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL;

/** Hosted brand roster. Kore Velum is baked in as an anchor tenant; the rest
 * come from the /api/applications/approved/brand feed. */
const BrandsHub = () => {
  const { current } = useAuth();
  const [approved, setApproved] = useState([]);

  useEffect(() => {
    document.title = "TMM|HOSTED BRANDS";
    (async () => {
      try {
        const r = await fetch(`${API}/api/applications/approved/brand`);
        const d = await r.json();
        setApproved(d.applications || []);
      } catch {
        /* ignore */
      }
    })();
  }, []);

  const canApply = current && current.status === "approved";

  return (
    <>
      <Header hoverColor={pageColors.fashion} compact={false} />
      <div className="brands-page">
        <header className="brands-hero">
          <h1 className="brands-title">Hosted Brands</h1>
          <p className="brands-lead">
            Independent houses growing inside The Monde Mania. Apply below to be featured.
          </p>
        </header>

        <article className="brand-showcase" data-testid="brand-showcase-kv">
          <div className="brand-showcase-name">
            <img src="/img/kv.png" alt="Kore Velum" />
          </div>
          <div className="brand-showcase-grid">
            <div className="brand-showcase-tile">
              <img src="/img/kvfront.png" alt="Kore Velum tee — front" />
              <div className="brand-showcase-cap">Front — poor man's tee</div>
            </div>
            <div className="brand-showcase-tile">
              <img src="/img/kvback.png" alt="Kore Velum tee — back" />
              <div className="brand-showcase-cap">Back — sphinx tee</div>
            </div>
          </div>
          <p className="brand-showcase-blurb">
            Distressed, hand-lettered gothic streetwear. Anchor tenant of Hosted Brands.
          </p>
        </article>

        {approved.length > 0 && (
          <section className="brand-roster">
            <h2 className="brand-roster-title">Also on the roster</h2>
            <div className="brand-roster-grid">
              {approved.map((b) => (
                <article key={b.id} className="brand-card" data-testid={`brand-card-${b.id}`}>
                  {b.hero_image_url && (
                    <div className="brand-card-cover">
                      <img src={b.hero_image_url} alt={b.display_name} />
                    </div>
                  )}
                  <div className="brand-card-body">
                    <div className="brand-card-name">{b.display_name}</div>
                    {b.tagline && <div className="brand-card-tag">{b.tagline}</div>}
                    <p className="brand-card-pitch">{b.pitch}</p>
                    <div className="brand-card-links">
                      {b.instagram && (
                        <a
                          href={b.instagram.startsWith("http") ? b.instagram : `https://instagram.com/${b.instagram.replace(/^@/, "")}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Instagram size={14} /> {b.instagram}
                        </a>
                      )}
                      {b.website && (
                        <a href={b.website} target="_blank" rel="noopener noreferrer">website</a>
                      )}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </section>
        )}

        <div className="brands-cta">
          {canApply ? (
            <Link to="/apply/brand" className="btn-solid btn-huge" data-testid="brands-apply-btn">
              Apply your brand <ArrowRight size={16} />
            </Link>
          ) : (
            <p className="brands-cta-note">
              Approved members can apply from here. <Link to="/members">Sign in</Link>.
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default BrandsHub;
